import { useEffect, useState } from "react";
import { fetchProducts } from "../lib/api";
import ProductCard from "../components/ProductCard";

const Shop = () => {
    const [products, setProducts] = useState([]);
    const [filter, setFilter] = useState("all");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchProducts()
            .then((p) => {
                setProducts(p);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, []);

    const visible = products.filter((p) =>
        filter === "all"
            ? true
            : filter === "available"
              ? p.status === "available"
              : p.status === "coming_soon",
    );

    return (
        <div data-testid="page-shop">
            <section className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-20 pt-16 md:pt-24 pb-8">
                <p className="text-[11px] tracking-[0.35em] uppercase text-[#9E5A35] mb-4">
                    Shop
                </p>
                <h1 className="font-serif-display text-5xl md:text-6xl lg:text-7xl text-[#0A2342] leading-[1.02] tracking-tight">
                    The Collection.
                </h1>
                <p className="mt-6 max-w-xl text-base md:text-lg text-[#1A1A1A]/80">
                    Hand-stitched needlepoint fobs, small-batch and made to
                    last. Every design at $22.
                </p>
            </section>

            <section className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-20">
                <div className="flex items-center gap-6 border-y border-[#E5E0D8] py-4">
                    {[
                        { k: "all", l: "All" },
                        { k: "available", l: "Available" },
                        { k: "coming_soon", l: "Coming Soon" },
                    ].map((f) => (
                        <button
                            key={f.k}
                            data-testid={`shop-filter-${f.k}`}
                            onClick={() => setFilter(f.k)}
                            className={`text-[11px] tracking-[0.22em] uppercase transition-colors ${
                                filter === f.k
                                    ? "text-[#0A2342]"
                                    : "text-[#5C6A79] hover:text-[#0A2342]"
                            }`}
                        >
                            {f.l}
                        </button>
                    ))}
                </div>
            </section>

            <section className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-20 py-12 md:py-16">
                {loading ? (
                    <div
                        data-testid="shop-loading"
                        className="text-center py-20 text-[#5C6A79] text-sm tracking-[0.22em] uppercase"
                    >
                        Loading collection…
                    </div>
                ) : (
                    <div
                        data-testid="shop-grid"
                        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8"
                    >
                        {visible.map((p) => (
                            <ProductCard key={p.id} product={p} />
                        ))}
                    </div>
                )}
            </section>
        </div>
    );
};

export default Shop;
